export const PHOTOS_PERMISSIONS = {
  VIEW: 'PricingAssistant.view_images',
  ADD: 'PricingAssistant.add_images',
  CHANGE: 'PricingAssistant.change_images',
  DELETE: 'PricingAssistant.delete_images',
};

export const PHOTOS_EDIT_PERMISSIONS = [PHOTOS_PERMISSIONS.ADD, PHOTOS_PERMISSIONS.CHANGE, PHOTOS_PERMISSIONS.DELETE];
